import { Type } from '@angular/core';
import { QuestionResponse, QuestionAnswerInstanceResponse } from '../public-api';

export class QuestionItem {
  constructor(public component: Type<any>, public questionData: QuestionResponse, public questionAnswerInstanceList: QuestionAnswerInstanceResponse[]) {}
}
